import { render, staticRenderFns } from "./RealTimeVideo.vue?vue&type=template&id=33627150&scoped=true"
import script from "./RealTimeVideo.vue?vue&type=script&lang=js"
export * from "./RealTimeVideo.vue?vue&type=script&lang=js"
import style0 from "./RealTimeVideo.vue?vue&type=style&index=0&id=33627150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33627150",
  null
  
)

export default component.exports